/**
 * Logger utility com timestamp e cores para console
 * Facilita debug do fluxo assíncrono
 */

const colors = {
  reset: '\x1b[0m',
  bright: '\x1b[1m',
  dim: '\x1b[2m',
  red: '\x1b[31m',
  green: '\x1b[32m',
  yellow: '\x1b[33m',
  blue: '\x1b[34m',
  cyan: '\x1b[36m',
  magenta: '\x1b[35m',
};

function timestamp() {
  return new Date().toLocaleTimeString('pt-BR', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    fractionalSecondDigits: 3,
  });
}

const logger = {
  // POST /processar-completa
  logPostResponse: (data) => {
    console.group(
      `${colors.bright}${colors.green}✅ POST /processar-completa (202)${colors.reset} ${colors.dim}${timestamp()}${colors.reset}`
    );
    console.log('Status:', 202);
    console.log('Task ID:', data.task_id);
    console.log('NC ID:', data.nc_id);
    console.log('NC Number:', data.numero_nc);
    console.log('Initial Status:', data.status);
    console.log('Full Response:', data);
    console.groupEnd();
  },

  // Erro no POST
  logPostError: (error) => {
    console.group(
      `${colors.bright}${colors.red}❌ POST /processar-completa ERROR${colors.reset} ${colors.dim}${timestamp()}${colors.reset}`
    );
    console.error('Error:', error.message);
    console.error('Full Error:', error);
    console.groupEnd();
  },

  // Entrada em NCProcessing
  logNCProcessingMount: (ncId, taskId, numeroNC) => {
    console.group(
      `${colors.bright}${colors.blue}🔄 NCProcessing MOUNT${colors.reset} ${colors.dim}${timestamp()}${colors.reset}`
    );
    console.log('NC ID:', ncId);
    console.log('Task ID:', taskId);
    console.log('NC Number:', numeroNC);
    console.log('Props received:', { ncId, taskId, numeroNC });
    console.groupEnd();
  },

  // Polling realizado
  logPolling: (status, progress, ncId, error = null) => {
    const icon =
      status === 'pending'
        ? '⏳'
        : status === 'processing'
        ? '⚙️'
        : status === 'completed'
        ? '✅'
        : status === 'failed'
        ? '❌'
        : '❓';

    const color =
      status === 'pending'
        ? colors.yellow
        : status === 'processing'
        ? colors.cyan
        : status === 'completed'
        ? colors.green
        : status === 'failed'
        ? colors.red
        : colors.dim;

    console.log(
      `${color}${icon} GET /analise-status${colors.reset} ${colors.dim}${timestamp()}${colors.reset} — Status: ${color}${status}${colors.reset}, Progress: ${progress}%`
    );

    if (error) {
      console.warn(`   Error: ${error}`);
    }
  },

  // Histórico de polls (para debug de timeout)
  logPollingHistory: (history) => {
    console.group(
      `${colors.bright}${colors.magenta}📊 Polling History (Timeout)${colors.reset} ${colors.dim}${timestamp()}${colors.reset}`
    );
    console.table(history);
    console.log(`Total polls: ${history.length}`);
    console.log(`Duration: ${history.length * 2}s (2s per poll)`);
    console.groupEnd();
  },

  // Completado e saindo para NCResult
  logProcessingComplete: (ncData) => {
    console.group(
      `${colors.bright}${colors.green}✅ NCProcessing → NCResult${colors.reset} ${colors.dim}${timestamp()}${colors.reset}`
    );
    console.log('NC loaded successfully');
    console.log('NC ID:', ncData.id);
    console.log('Status:', ncData.workflow_status);
    console.log('NC Data keys:', Object.keys(ncData));
    console.groupEnd();
  },

  // Erro durante processamento
  logProcessingError: (errorMsg, ncId) => {
    console.group(
      `${colors.bright}${colors.red}❌ NCProcessing ERROR${colors.reset} ${colors.dim}${timestamp()}${colors.reset}`
    );
    console.error('Error Message:', errorMsg);
    console.error('NC ID:', ncId);
    console.error('Returning to NCList');
    console.groupEnd();
  },

  // Hook effect triggers
  logHookEffect: (triggerReason, values) => {
    console.log(
      `${colors.dim}[Hook Effect] ${triggerReason} ${timestamp()}${colors.reset}`,
      values
    );
  },

  // Generic info
  info: (label, data) => {
    console.log(`${colors.cyan}ℹ️ ${label}${colors.reset}`, data);
  },

  // Generic warning
  warn: (label, data) => {
    console.warn(`${colors.yellow}⚠️ ${label}${colors.reset}`, data);
  },

  // Generic error
  error: (label, data) => {
    console.error(`${colors.red}❌ ${label}${colors.reset}`, data);
  },
};

export default logger;
